/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_YesterdayInputs */

const en_history_yesterday = /** @type {(inputs: History_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

const de_history_yesterday = /** @type {(inputs: History_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestern`)
};

/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {History_YesterdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_yesterday = /** @type {((inputs?: History_YesterdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_YesterdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_yesterday(inputs)
	return en_history_yesterday(inputs)
});